var ScriptingObjectNames = /* @__PURE__ */ ((ScriptingObjectNames2) => {
  ScriptingObjectNames2["Analytics"] = "analytics";
  ScriptingObjectNames2["Application"] = "application";
  ScriptingObjectNames2["Auth"] = "auth";
  ScriptingObjectNames2["Form"] = "form";
  ScriptingObjectNames2["Global"] = "global";
  ScriptingObjectNames2["Http"] = "http";
  ScriptingObjectNames2["Loan"] = "loan";
  ScriptingObjectNames2["LoanV2"] = "loanV2";
  ScriptingObjectNames2["MemStorage"] = "memstorage";
  ScriptingObjectNames2["Module"] = "module";
  ScriptingObjectNames2["Service"] = "service";
  ScriptingObjectNames2["Session"] = "session";
  ScriptingObjectNames2["Styling"] = "styling";
  ScriptingObjectNames2["Transaction"] = "transaction";
  ScriptingObjectNames2["TransactionTemplate"] = "transactiontemplate";
  ScriptingObjectNames2["WebSocket"] = "websocket";
  return ScriptingObjectNames2;
})(ScriptingObjectNames || {});
export {
  ScriptingObjectNames
};
